<label>
  @if (field.label) {
    <div
      class="form-field__label form-field__text-label"
      [class.form-field__label--error]="showError"
    >
      {{ field.label | translateInline }}
    </div>
  }
  <!-- For some inputs we can supply a value transformation for better UX -->
  <input
    class="form-field__input form-field__text-input"
    [class.form-field__input--error]="showError"
    [class.form-field__text-input--readonly]="isReadonly"
    [disabled]="isReadonly"
    type="text"
    [attr.inputmode]="inputmode"
    [attr.autocapitalize]="autocapitalize"
    [attr.autocomplete]="autocomplete()"
    [(ngModel)]="value"
    [fmntsValueTransform]="_displayValueTransformer"
    (blur)="_onTouched()"
  />

  <div class="form-field__error-message">
    @if (showError && control.errors) {
      @if (
        control.errors | declarativeErrorMessage: field : declaration;
        as errorMsg
      ) {
        <div>
          {{ errorMsg }}
        </div>
        @if (canDismissError()) {
          <button
            type="button"
            fmnts-button
            action="destructive"
            variant="filled"
            (click)="dismissAllErrors()"
          >
            {{ 'accept' | translate }}
          </button>
        }
      }
    }
  </div>
</label>
